import React, { useState } from 'react';
import API from '../services/api';

function AdminNewUserPage() {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    password: '',
    role: 'THERAPIST',
    practiceId: '' // NEW
  });

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      // POST /admin/users
      await API.post('/admin/users', {
        role: formData.role,
        firstName: formData.firstName,
        lastName: formData.lastName,
        email: formData.email,
        password: formData.password,
        practiceId: formData.practiceId || 1 // or any default you prefer
      });
      alert('User created successfully!');
      setFormData({
        firstName: '',
        lastName: '',
        email: '',
        password: '',
        role: 'THERAPIST',
        practiceId: ''
      });
    } catch (error) {
      console.error('Error creating user:', error);
      alert('Error creating user');
    }
  };

  return (
    <div>
      <h2>Create New User</h2>
      <form onSubmit={handleSubmit}>

        <div>
          <label>First Name:</label><br />
          <input
            name="firstName"
            value={formData.firstName}
            onChange={handleChange}
            required
          />
        </div>

        <div>
          <label>Last Name:</label><br />
          <input
            name="lastName"
            value={formData.lastName}
            onChange={handleChange}
            required
          />
        </div>

        <div>
          <label>Email:</label><br />
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
          />
        </div>

        <div>
          <label>Password:</label><br />
          <input
            type="password"
            name="password"
            value={formData.password}
            onChange={handleChange}
            required
          />
        </div>

        <div>
          <label>Role:</label><br />
          <select
            name="role"
            value={formData.role}
            onChange={handleChange}
          >
            <option value="THERAPIST">Therapist</option>
            <option value="OFFICE_ADMIN">Office Admin</option>
            <option value="PORTAL_ADMIN">Portal Admin</option>
          </select>
        </div>

        {/* New field for practiceId */}
        <div>
          <label>Practice ID:</label><br />
          <input
            type="number"
            name="practiceId"
            value={formData.practiceId}
            onChange={handleChange}
          />
        </div>

        <button type="submit" style={{ marginTop: '1rem' }}>
          Create User
        </button>
      </form>
    </div>
  );
}

export default AdminNewUserPage;
